/* ------------------------------------------------------------------
   Bluebells Cakery - Custom Icing Colour add-on for the Atlas CVP.

   WHERE THINGS LIVE
   -----------------
   Colours, labels and the footnote are the DEFAULTS block below - edit
   them here once and every product picks them up. The price is NOT
   stored anywhere in the theme: it is read live from the surcharge
   product, so changing the price of `custom-icing-colour` in Shopify is
   the only edit needed.

   A product opts in by adding this to its extra_fields step JSON:

       "more_options": {}

   Any key you put in that object overrides the default for that product
   only - e.g. "more_options": { "options": [ ...a shorter list... ] }.

   HOW IT WORKS
   ------------
   The button sits under the step's free swatches and opens a modal.
   Modal tiles are plain buttons holding a PENDING choice; nothing
   reaches the product page until Done is clicked, which copies the
   choice onto a single hidden CVP radio carrying `data-handle` (the
   surcharge product) and `data-price-cents`. That radio shares the
   step's radio group, so the existing recomputeSelections /
   recomputeTotal / add-to-cart pipeline picks it up unchanged and
   choosing a free colour unchecks it automatically.

   Once a colour is committed the button becomes "Remove Colour Options
   - $15" and one click clears the colour and its surcharge.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SWATCH_BASE = 'https://cdn.shopify.com/s/files/1/0884/4436/files/';

  var DEFAULTS = {
    handle: 'custom-icing-colour',
    /* {price} is filled in from the live product price */
    button_label: 'More Colour Options - {price}',
    remove_label: 'Remove Colour Options - {price}',
    modal_title: 'Custom Colours - {price}',
    note: '*denotes colours that may temporarily stain your teeth/mouth due to amount of colouring required to achieve that colour',
    options: [
      { name_override: 'White',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_White.png?v=1787786576' },
      { name_override: 'Lemon',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Lemon.png?v=1741128540' },
      { name_override: 'Peach',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Peach.png?v=1741128760' },
      { name_override: 'Yellow',   image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Yellow.png?v=1787785395' },
      { name_override: 'Candy',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Candy.png?v=1741129282' },
      { name_override: 'Sage',     image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Sage.png?v=1787785396' },
      { name_override: 'Green',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Green.png?v=1787785395' },
      { name_override: 'Hot Pink', image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Hot_Pink.png?v=1787785395' },
      { name_override: 'Sky Blue', image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Sky_Blue.png?v=1741129273' },
      { name_override: 'Teal',     image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2025_-_FINAL_Teal.png?v=1741129295' },
      { name_override: 'Burgundy', image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Burgundy_V2.png?v=1789439595' },
      { name_override: 'Orange',   image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Orange.png?v=1789439595' },
      { name_override: 'Purple',   image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Purple.png?v=1789439595' },
      { name_override: 'Black',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Black.png?v=1789439595' },
      { name_override: 'Red',      image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Red.png?v=1789439595' },
      { name_override: 'Royal',    image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Royal.png?v=1789439595' },
      { name_override: 'Forest',   image_override: SWATCH_BASE + 'BLUEBELLS_COLOUR_SWATCHES_2026_Forest.png?v=1789439595' }
    ]
  };

  var STYLE_ID = 'atlas-cvp-cc-styles';
  var VALUE_PREFIX = 'Custom - ';
  var PINK = '#FBE7E6';
  var NAVY = '#262967';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      /* trigger button - pink ground, navy type, theme button geometry */
      '.atlas-cvp__more{margin-top:18px;display:flex;flex-wrap:wrap;align-items:center;gap:12px 16px}',
             '.atlas-cvp__more-btn.button{background:' + PINK + ';color:' + NAVY + ';border:1px solid ' + PINK + ';',
      'width:282px;max-width:100%;padding-left:24px;padding-right:24px;',
      'box-shadow:none;cursor:pointer}',
      '.atlas-cvp__more-btn.button:hover{background:#F5D4D2;border-color:#F5D4D2;color:' + NAVY + '}',
      '.atlas-cvp__more-summary{font-size:14px;font-weight:500;color:' + NAVY + '}',
      '.atlas-cvp__more-summary:empty{display:none}',

      /* modal */
      '.atlas-cvp__more-dialog{border:none;border-radius:10px;padding:0;max-width:920px;',
      'width:calc(100% - 32px);background:' + PINK + ';color:' + NAVY + ';overflow:visible}',
      '.atlas-cvp__more-dialog::backdrop{background:rgba(38,41,103,.42)}',
      '.atlas-cvp__more-inner{padding:28px 28px 8px;max-height:72vh;overflow-y:auto}',
      '.atlas-cvp__more-title.h2{font-size:28px;font-weight:200;text-decoration:underline;',
      'margin:0 0 20px;padding-right:40px;color:' + NAVY + ';line-height:1.2}',
      '.atlas-cvp__more-close{position:absolute;top:14px;right:14px;width:30px;height:30px;',
      'border-radius:50%;border:1px solid ' + NAVY + ';background:#FFFDF8;color:' + NAVY + ';',
      'font-size:18px;line-height:1;cursor:pointer;padding:0;z-index:2}',
            '.atlas-cvp__more-note{margin:20px 0 0;font-size:12px;line-height:1.55;color:' + NAVY + ' !important}',
      '.atlas-cvp__more-footer{display:flex;justify-content:flex-end;background:' + PINK + ';',
      'padding:12px 16px 16px;border-radius:0 0 10px 10px}',

      /* tiles - plain buttons, so neither the hover-preview script nor the */
      /* CVP's radio scanning touches them until Done is clicked */
      '.atlas-cvp__cc-swatches{display:grid;grid-template-columns:repeat(auto-fill,minmax(100px,1fr));gap:10px}',
      '.atlas-cvp__cc-swatch{display:block;width:100%;cursor:pointer;border:1px solid #f1f1f1;',
      'border-radius:10px;padding:5px;background:#fff;font:inherit;color:inherit;text-align:center}',
      '.atlas-cvp__cc-swatch.is-selected{border-color:' + NAVY + ';box-shadow:0 0 0 1px ' + NAVY + '}',
      '.atlas-cvp__cc-visual{display:flex;aspect-ratio:1/1;width:100%}',
      '.atlas-cvp__cc-visual img{border-radius:0;aspect-ratio:1/1;width:100%;height:100%;object-fit:contain}',
      '.atlas-cvp__cc-dot{display:block;width:100%;aspect-ratio:1/1;border-radius:8px;background:#ccc}',
      '@media (max-width:480px){.atlas-cvp__more-inner{padding:22px 18px 8px}',
      '.atlas-cvp__cc-swatches{grid-template-columns:repeat(auto-fill,minmax(84px,1fr))}}'
    ].join('');
    document.head.appendChild(s);
  }

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src || typeof src !== 'object') continue;
      for (var k in src) {
        if (Object.prototype.hasOwnProperty.call(src, k) && src[k] !== undefined && src[k] !== null) {
          target[k] = src[k];
        }
      }
    }
    return target;
  }

  function radioGroupName(stepName) {
    return 'cvp__' + String(stepName).replace(/\s+/g, '-').toLowerCase();
  }

  function slug(str) {
    return String(str).replace(/\s+/g, '-').toLowerCase().replace(/[^a-z0-9-]/g, '');
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || !isFinite(cents)) return '';
    var whole = cents / 100;
    return '$' + (cents % 100 === 0 ? String(whole) : whole.toFixed(2));
  }

  /* "More Colour Options - {price}" -> "More Colour Options - $15", and
     tidily drops the separator when there is no price to show. */
  function fill(tpl, priceStr) {
    if (!tpl) return '';
    if (priceStr) return tpl.replace(/\{price\}/g, priceStr);
    return tpl.replace(/\s*[-–]\s*\{price\}/g, '').replace(/\{price\}/g, '').trim();
  }

  /* Live price lookup, one request per handle per page. */
  var priceCache = {};
  function resolvePrice(handle, cb) {
    if (!handle) return cb(null);
    if (Object.prototype.hasOwnProperty.call(priceCache, handle)) return cb(priceCache[handle]);
    if (typeof window.fetch !== 'function') { priceCache[handle] = null; return cb(null); }
    window.fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cents = (j && typeof j.price === 'number') ? j.price : null;
        priceCache[handle] = cents;
        cb(cents);
      })
      .catch(function () { priceCache[handle] = null; cb(null); });
  }

  function openDialog(dlg) {
    try {
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    } catch (e) {
      dlg.setAttribute('open', '');
    }
  }

  function closeDialog(dlg) {
    try {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    } catch (e) {
      dlg.removeAttribute('open');
    }
  }

  /* Build the button + modal for one step. */
  function build(root, stepEl, stepName, cfg) {
    var uid = root.dataset.uid || 'cvp';
    var formId = root.dataset.formId || '';
    var options = (cfg.options || []).filter(Boolean);
    if (!options.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'atlas-cvp__more';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--primary atlas-cvp__more-btn';

    var summary = document.createElement('span');
    summary.className = 'atlas-cvp__more-summary';

    /* The one real CVP input. Only written to when Done is clicked. */
    var hidden = document.createElement('input');
    hidden.type = 'radio';
    hidden.className = 'atlas-cvp__input';
    hidden.name = radioGroupName(stepName);
    hidden.id = 'cvp-cc-' + uid + '-' + slug(stepName) + '-selected';
    hidden.value = '';
    hidden.setAttribute('data-handle', cfg.handle || '');
    hidden.setAttribute('data-price-cents', '0');
    hidden.setAttribute('data-cvp-custom-colour', '');
    hidden.style.display = 'none';
    if (formId) hidden.setAttribute('form', formId);

    var dlg = document.createElement('dialog');
    dlg.className = 'atlas-cvp__more-dialog';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'atlas-cvp__more-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    dlg.appendChild(close);

    var inner = document.createElement('div');
    inner.className = 'atlas-cvp__more-inner';

    var title = document.createElement('h2');
    title.className = 'h2 atlas-cvp__more-title';
    inner.appendChild(title);

    var grid = document.createElement('div');
    grid.className = 'atlas-cvp__cc-swatches';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', stepName);

    var pending = null;
    var tiles = [];

    function paint() {
      tiles.forEach(function (t) {
        var on = t.getAttribute('data-colour') === pending;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    options.forEach(function (opt, i) {
      var label = opt.name_override || opt.handle || ('Option ' + (i + 1));

      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'atlas-cvp__cc-swatch';
      tile.setAttribute('role', 'radio');
      tile.setAttribute('aria-checked', 'false');
      tile.setAttribute('aria-label', label);
      tile.setAttribute('data-colour', label);

      var vis = document.createElement('span');
      vis.className = 'atlas-cvp__cc-visual';

      var thumb;
      if (opt.image_override && typeof opt.image_override === 'string') {
        thumb = document.createElement('img');
        thumb.src = opt.image_override;
        thumb.alt = label;
        thumb.loading = 'lazy';
      } else {
        thumb = document.createElement('span');
        thumb.className = 'atlas-cvp__cc-dot';
      }
      vis.appendChild(thumb);
      tile.appendChild(vis);

      tile.addEventListener('click', function () {
        pending = label;
        paint();
      });

      tiles.push(tile);
      grid.appendChild(tile);
    });

    inner.appendChild(grid);

    if (cfg.note) {
      var note = document.createElement('p');
      note.className = 'atlas-cvp__more-note';
      note.textContent = cfg.note;
      inner.appendChild(note);
    }

    dlg.appendChild(inner);

    var footer = document.createElement('div');
    footer.className = 'atlas-cvp__more-footer';
    var done = document.createElement('button');
    done.type = 'button';
    done.className = 'button button--primary atlas-cvp__more-done';
    done.textContent = 'Done';
    footer.appendChild(done);
    dlg.appendChild(footer);

    wrap.appendChild(btn);
    wrap.appendChild(summary);
    wrap.appendChild(hidden);
    wrap.appendChild(dlg);
    stepEl.appendChild(wrap);

    /* Labels and surcharge come from the live product price. */
    function applyPrice(cents) {
      var priceStr = formatMoney(cents);
      wrap.setAttribute('data-add-label', fill(cfg.button_label, priceStr) || 'More Colour Options');
      wrap.setAttribute('data-remove-label', fill(cfg.remove_label, priceStr) || 'Remove');
      title.textContent = fill(cfg.modal_title, priceStr) || 'Custom Colours';
      hidden.setAttribute('data-price-cents', String(cents || 0));
      refreshSummary(stepEl);
      if (hidden.checked) hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (typeof cfg.price === 'number') {
      applyPrice(cfg.price);
    } else {
      applyPrice(null);
      resolvePrice(cfg.handle, applyPrice);
    }

    btn.addEventListener('click', function () {
      /* Once a colour is committed the button becomes Remove: one click */
      /* clears the colour and its surcharge. */
      if (hidden.checked) {
        hidden.checked = false;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
        pending = null;
        paint();
        refreshSummary(stepEl);
        return;
      }
      pending = null;
      paint();
      openDialog(dlg);
    });

    close.addEventListener('click', function () { closeDialog(dlg); });

    done.addEventListener('click', function () {
      if (pending) {
        hidden.value = VALUE_PREFIX + pending;
        hidden.setAttribute('data-cvp-custom-colour', pending);
        hidden.checked = true;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (hidden.checked) {
        hidden.checked = false;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
      refreshSummary(stepEl);
      closeDialog(dlg);
    });
  }

  /* Keep the summary and the button label in step with what is committed. */
  function refreshSummary(stepEl) {
    var wrap = stepEl.querySelector('.atlas-cvp__more');
    if (!wrap) return;
    var summary = wrap.querySelector('.atlas-cvp__more-summary');
    var checked = stepEl.querySelector('input.atlas-cvp__input[type="radio"]:checked');
    var custom = checked && checked.getAttribute('data-cvp-custom-colour');
    if (summary) summary.textContent = custom ? '✓ ' + custom : '';

    var btn = wrap.querySelector('.atlas-cvp__more-btn');
    if (btn) {
      var label = custom
        ? wrap.getAttribute('data-remove-label')
        : wrap.getAttribute('data-add-label');
      if (label) btn.textContent = label;
    }
  }

  function initRoot(root) {
    if (root.__cvpCustomColours) return;
    root.__cvpCustomColours = true;

    var stepsEl = root.querySelector('script[data-cvp-steps]');
    if (!stepsEl) return;

    var steps;
    try {
      steps = JSON.parse(stepsEl.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!Array.isArray(steps)) return;

    var configs = [];
    steps.forEach(function (s, i) {
      if (!s || s.more_options === undefined || s.more_options === null || s.more_options === false) return;
      var override = (typeof s.more_options === 'object') ? s.more_options : {};
      var cfg = assign({}, DEFAULTS, override);
      if (!cfg.options || !cfg.options.length) return;
      configs.push({ stepName: s.name || s.label || ('Step ' + (i + 1)), cfg: cfg });
    });
    if (!configs.length) return;

    injectStyles();

    function scan() {
      configs.forEach(function (entry) {
        var stepEls = root.querySelectorAll('.atlas-cvp__step[data-step-name]');
        for (var i = 0; i < stepEls.length; i++) {
          var stepEl = stepEls[i];
          if (stepEl.getAttribute('data-step-name') !== entry.stepName) continue;
          if (stepEl.querySelector('.atlas-cvp__more')) continue;
          build(root, stepEl, entry.stepName, entry.cfg);
        }
      });
    }

    var pendingScan = null;
    function scheduleScan() {
      if (pendingScan) return;
      pendingScan = window.setTimeout(function () {
        pendingScan = null;
        try { scan(); } catch (e) {}
      }, 0);
    }

    scheduleScan();

    /* Belt and braces: steps can render after the observer attaches. */
    var tries = 0;
    var poll = window.setInterval(function () {
      tries += 1;
      try { scan(); } catch (e) {}
      if (tries >= 20) window.clearInterval(poll);
    }, 250);

    var mo = new MutationObserver(scheduleScan);
    mo.observe(root, { childList: true, subtree: true });

    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.matches || !t.matches('input.atlas-cvp__input[type="radio"]')) return;
      var stepEl = t.closest('.atlas-cvp__step');
      if (stepEl) refreshSummary(stepEl);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('.atlas-custom-variant-picker');
    for (var i = 0; i < roots.length; i++) {
      try { initRoot(roots[i]); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
}());
